export default "__VITE_ASSET__D52whYmq__"